import { z } from 'zod';

import { EmailSchema } from '@vestigas/utils';

/**
 * Zod schema for the optional resend activation payload.
 *
 * The body is nullable at the API level — when omitted the original email is reused.
 */
export const zodResendActivationPayloadSchema = z
  .object({
    supplierEmail: EmailSchema.nullish(),
  })
  .nullish();
